// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes homeFadeUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes homeFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}
.homePage .homeChoose {
  padding: clamp(3.5rem, 8vw, 6rem) 0;
  background: #ffffff;
}
.homePage .homeChoose__inner {
  width: min(1120px, 100% - 2.5rem);
  margin-inline: auto;
  width: min(1120px, 100%);
}
.homePage .homeChoose__panel {
  height: 100%;
  padding: clamp(1.6rem, 3vw, 2.25rem);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.homePage .homeChoose__panel h3 {
  margin: 1rem 0 0.35rem;
  font-size: 1.45rem;
  font-weight: 700;
}
.homePage .homeChoose__panel > p:not(.homeChoose__eyebrow) {
  margin: 0 0 1.4rem;
  line-height: 1.6;
  flex: 1 1;
}
.homePage .homeChoose__panel--soft {
  background: #f4f7fb;
  border: 1px solid rgba(26, 31, 44, 0.08);
  color: #1a1f2c;
}
.homePage .homeChoose__panel--soft .homeChoose__eyebrow {
  color: #1a9fd4;
}
.homePage .homeChoose__panel--soft > p:not(.homeChoose__eyebrow) {
  color: #5c6578;
}
.homePage .homeChoose__panel--soft .homeChoose__icon {
  background: rgba(63, 185, 234, 0.14);
  color: #1a9fd4;
}
.homePage .homeChoose__panel--teal {
  background: radial-gradient(circle at 90% 10%, rgba(255, 255, 255, 0.22), transparent 40%), linear-gradient(145deg, #3fb9ea 0%, #1a9fd4 100%);
  color: #fff;
  border: 1px solid transparent;
}
.homePage .homeChoose__panel--teal .homeChoose__eyebrow {
  color: rgba(255, 255, 255, 0.85);
}
.homePage .homeChoose__panel--teal > p:not(.homeChoose__eyebrow) {
  color: rgba(255, 255, 255, 0.92);
}
.homePage .homeChoose__panel--teal .homeChoose__icon {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
}
.homePage .homeChoose__eyebrow {
  margin: 0 0 0.75rem;
  font-size: 0.9rem;
  font-weight: 600;
}
.homePage .homeChoose__icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}
.homePage .homeChoose__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}
.homePage .homeChoose__btnLight {
  display: inline-flex;
  align-items: center;
  padding: 0.8rem 1.35rem;
  border-radius: 999px;
  background: #fff;
  color: #1a9fd4 !important;
  text-decoration: none !important;
  font-weight: 600;
  transition: transform 0.2s ease, background 0.2s ease;
}
.homePage .homeChoose__btnLight:hover {
  transform: translateY(-1px);
  background: #f3fbff;
}
.homePage .homeChoose__btnOutline {
  display: inline-flex;
  align-items: center;
  padding: 0.8rem 1.35rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.55);
  color: #fff !important;
  text-decoration: none !important;
  font-weight: 600;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.homePage .homeChoose__btnOutline:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/Components/Home/home-tokens.scss","webpack://./src/Components/Home/Choose/Style.scss"],"names":[],"mappings":"AA2BA;EACE;IACE,UAAA;IACA,2BAAA;EC1BF;ED4BA;IACE,UAAA;IACA,wBAAA;EC1BF;AACF;AD6BA;EACE;IAEE,wBAAA;EC5BF;ED8BA;IACE,4BAAA;EC5BF;AACF;AAfA;EACE,mCAAA;EACA,mBAAA;AAiBF;AAfE;EDMA,iCAAA;EACA,mBAAA;ECLE,wBAAA;AAkBJ;AAfE;EACE,YAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAiBJ;AAfI;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;AAiBN;AAdI;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;AAgBN;AAZE;EACE,mBD9BQ;EC+BR,wCAAA;EACA,cDnCO;ACiDX;AAZI;EACE,cDhCW;AC8CjB;AAXI;EACE,cDzCO;ACsDb;AAVI;EACE,oCAAA;EACA,cDzCW;ACqDjB;AARE;EACE,6IACE;EAEF,WAAA;EACA,6BAAA;AAQJ;AANI;EACE,gCAAA;AAQN;AALI;EACE,gCAAA;AAON;AAJI;EACE,qCAAA;EACA,WAAA;AAMN;AAFE;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;AAIJ;AADE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAGJ;AAAE;EACE,aAAA;EACA,eAAA;EACA,YAAA;AAEJ;AACE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,qDAAA;AACJ;AACI;EACE,2BAAA;EACA,mBAAA;AACN;AAGE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2CAAA;EACA,sBAAA;EACA,gCAAA;EACA,gBAAA;EACA,wDAAA;AADJ;AAGI;EACE,qCAAA;EACA,kBAAA;AADN","sourcesContent":["$home-ink: #1a1f2c;\r\n$home-muted: #5c6578;\r\n$home-line: rgba(26, 31, 44, 0.08);\r\n$home-mist: #f4f7fb;\r\n$home-paper: #ffffff;\r\n$home-teal: #3fb9ea;\r\n$home-teal-deep: #1a9fd4;\r\n$home-red: #d60000;\r\n$home-display: \"Plus Jakarta Sans\", system-ui, sans-serif;\r\n$home-body: \"Outfit\", system-ui, sans-serif;\r\n\r\n@mixin home-container {\r\n  width: min(1120px, calc(100% - 2.5rem));\r\n  margin-inline: auto;\r\n}\r\n\r\n@mixin home-reveal {\r\n  opacity: 0;\r\n  transform: translateY(28px);\r\n  transition: opacity 0.7s ease, transform 0.7s ease;\r\n\r\n  &.is-visible {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFadeUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(24px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFloat {\r\n  0%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-12px);\r\n  }\r\n}\r\n","@import \"../home-tokens.scss\";\r\n\r\n.homePage .homeChoose {\r\n  padding: clamp(3.5rem, 8vw, 6rem) 0;\r\n  background: $home-paper;\r\n\r\n  &__inner {\r\n    @include home-container;\r\n    width: min(1120px, 100%);\r\n  }\r\n\r\n  &__panel {\r\n    height: 100%;\r\n    padding: clamp(1.6rem, 3vw, 2.25rem);\r\n    border-radius: 24px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n\r\n    h3 {\r\n      margin: 1rem 0 0.35rem;\r\n      font-size: 1.45rem;\r\n      font-weight: 700;\r\n    }\r\n\r\n    > p:not(.homeChoose__eyebrow) {\r\n      margin: 0 0 1.4rem;\r\n      line-height: 1.6;\r\n      flex: 1;\r\n    }\r\n  }\r\n\r\n  &__panel--soft {\r\n    background: $home-mist;\r\n    border: 1px solid $home-line;\r\n    color: $home-ink;\r\n\r\n    .homeChoose__eyebrow {\r\n      color: $home-teal-deep;\r\n    }\r\n\r\n    > p:not(.homeChoose__eyebrow) {\r\n      color: $home-muted;\r\n    }\r\n\r\n    .homeChoose__icon {\r\n      background: rgba(63, 185, 234, 0.14);\r\n      color: $home-teal-deep;\r\n    }\r\n  }\r\n\r\n  &__panel--teal {\r\n    background:\r\n      radial-gradient(circle at 90% 10%, rgba(255, 255, 255, 0.22), transparent 40%),\r\n      linear-gradient(145deg, #3fb9ea 0%, #1a9fd4 100%);\r\n    color: #fff;\r\n    border: 1px solid transparent;\r\n\r\n    .homeChoose__eyebrow {\r\n      color: rgba(255, 255, 255, 0.85);\r\n    }\r\n\r\n    > p:not(.homeChoose__eyebrow) {\r\n      color: rgba(255, 255, 255, 0.92);\r\n    }\r\n\r\n    .homeChoose__icon {\r\n      background: rgba(255, 255, 255, 0.18);\r\n      color: #fff;\r\n    }\r\n  }\r\n\r\n  &__eyebrow {\r\n    margin: 0 0 0.75rem;\r\n    font-size: 0.9rem;\r\n    font-weight: 600;\r\n  }\r\n\r\n  &__icon {\r\n    width: 52px;\r\n    height: 52px;\r\n    border-radius: 16px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  &__actions {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 0.65rem;\r\n  }\r\n\r\n  &__btnLight {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    padding: 0.8rem 1.35rem;\r\n    border-radius: 999px;\r\n    background: #fff;\r\n    color: $home-teal-deep !important;\r\n    text-decoration: none !important;\r\n    font-weight: 600;\r\n    transition: transform 0.2s ease, background 0.2s ease;\r\n\r\n    &:hover {\r\n      transform: translateY(-1px);\r\n      background: #f3fbff;\r\n    }\r\n  }\r\n\r\n  &__btnOutline {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    padding: 0.8rem 1.35rem;\r\n    border-radius: 999px;\r\n    border: 1px solid rgba(255, 255, 255, 0.55);\r\n    color: #fff !important;\r\n    text-decoration: none !important;\r\n    font-weight: 600;\r\n    transition: background 0.2s ease, border-color 0.2s ease;\r\n\r\n    &:hover {\r\n      background: rgba(255, 255, 255, 0.12);\r\n      border-color: #fff;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
